<div class="card p-3 mt-2">
    <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="d-flex flex-column">
      <div class="title">API Key</div>
    </nz-skeleton>

    <nz-tabset
      class="mt-4"
      [nzSelectedIndex]="selectedIndex"
      (nzSelectedIndexChange)="onSelectedIndexChange($event)">
      <nz-tab nzTitle="API Key"><app-api-key></app-api-key></nz-tab>
      <nz-tab nzTitle="Access"><app-referrer></app-referrer></nz-tab>
    </nz-tabset>
</div>
